export const SUPPORTED_FONT_VARIANTS = [
  { weight: 300, style: "normal", required: false },
  { weight: 400, style: "normal", required: true },
  { weight: 500, style: "normal", required: true },
  { weight: 600, style: "normal", required: false },
  { weight: 700, style: "normal", required: false },
  { weight: 800, style: "normal", required: false },
  { weight: 300, style: "italic", required: false },
  { weight: 400, style: "italic", required: false },
  { weight: 500, style: "italic", required: false },
  { weight: 600, style: "italic", required: false },
  { weight: 700, style: "italic", required: false },
  { weight: 800, style: "italic", required: false },
] as const;

export const SUPPORTED_FONT_FORMATS = [
  {
    ext: "woff2",
    mime: ["font/woff2", "application/font-woff2"],
    cssFormatName: "woff2",
  },
  {
    ext: "woff",
    mime: ["font/woff", "application/font-woff"],
    cssFormatName: "woff",
  },
  {
    ext: "ttf",
    mime: ["font/ttf", "application/font-ttf"],
    cssFormatName: "truetype",
  },
  {
    ext: "otf",
    mime: ["font/otf", "application/font-otf"],
    cssFormatName: "opentype",
  },
] as const;

export const SYSTEM_FONTS = [
  "Arial",
  "Helvetica",
  "Verdana",
  "Tahoma",
  "Trebuchet MS",
  "Times New Roman",
  "Georgia",
  "Palatino",
  "Bookman",
  "Comic Sans MS",
  "Impact",
  "Lucida Sans Unicode",
  "Geneva",
  "Lucida Console",
].map((font) => ({
  family: font,
  id: font,
  type: "system" as const,
}));
